import React from "react";
import { Box, Typography } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import CommonIconButton from "@/modules/common/components/ui-kit/buttons/icon-button";
import { MoreHorizontal } from "lucide-react";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";

interface RatingActionItem {
  name: string;
  jsx: React.ReactNode;
}

interface GetRatingActionsParams {
  findInActivity?: () => void;
  onResolvedFollowUp?: () => void;
  onResolveClick: () => void;
  isResolved?: boolean;
  onActionClick?: () => void; // Callback to close dropdown
}

export const getRatingActions = ({
  findInActivity,
  onResolvedFollowUp,
  onResolveClick,
  isResolved,
  onActionClick,
}: GetRatingActionsParams): RatingActionItem[] => {
  const handleActionClick = (callback: () => void) => (e: React.MouseEvent) => {
    e.stopPropagation();
    callback();
    onActionClick?.();
  };

  return [
    ...(findInActivity
      ? [
          {
            name: "",
            jsx: (
              <Box
                onClick={handleActionClick(findInActivity)}
                sx={{
                  padding: nawyTheme.nawy.spacing.sm,
                  cursor: "pointer",
                  borderRadius: nawyTheme.nawy.radius.md,
                  "&:hover": {
                    backgroundColor:
                      nawyTheme.nawy.colors.semantic.layer.secondary,
                  },
                }}
              >
                <Typography
                  sx={{
                    ...nawyTheme.nawy.typography.english.variants.body.md
                      .regular,
                    color: nawyTheme.nawy.colors.semantic.text.primary,
                  }}
                >
                  Find in activity
                </Typography>
              </Box>
            ),
          },
        ]
      : []),
    ...(onResolvedFollowUp && !isResolved
      ? [
          {
            name: "Resolve",
            jsx: (
              <PermissionGuard
                permissions={[
                  {
                    name: PermissionsEnum.CAN_ACCESS_WRITE_RATINGS,
                    level: PermissionLevel.WRITE,
                  },
                ]}
              >
                <Box
                  onClick={handleActionClick(onResolveClick)}
                  sx={{
                    padding: nawyTheme.nawy.spacing.sm,
                    cursor: "pointer",
                    borderRadius: nawyTheme.nawy.radius.md,
                    "&:hover": {
                      backgroundColor:
                        nawyTheme.nawy.colors.semantic.layer.secondary,
                    },
                  }}
                >
                  <Typography
                    sx={{
                      ...nawyTheme.nawy.typography.english.variants.body.md
                        .regular,
                      color: nawyTheme.nawy.colors.semantic.text.primary,
                    }}
                  >
                    Resolve
                  </Typography>
                </Box>
              </PermissionGuard>
            ),
          },
        ]
      : []),
  ];
};

export const getRatingTriggerButton = (
  handleClick: (event: React.MouseEvent<HTMLElement>) => void
) => (
  <CommonIconButton
    variant="outlined-secondary"
    size="md"
    onClick={handleClick}
  >
    <MoreHorizontal size={20} />
  </CommonIconButton>
);
